import { render } from "./subPopup.vue?vue&type=template&id=8b7d278a"
import script from "./subPopup.js?vue&type=script&lang=js"
export * from "./subPopup.js?vue&type=script&lang=js"

import "./subPopup.vue?vue&type=style&index=0&id=8b7d278a&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__